
(function($, window, undefined) {

  var defaults = {
    isSwiper:false,
    hasThumbs:true,
    onThumbClickCallback:false
  }

  function wbskGal(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.thumbs = $(`${this.settings.thumbsSwiperContainer}`)
    this.featImg = !this.settings.isSwiper ? this.element.find('.wbsk-gallery-feat-img') : false
    this.init()
  }

  wbskGal.prototype = {
    
    init: function() {      
      var _this = this
      
      if(this.settings.isSwiper && this.settings.items && this.settings.items.length > 0){
        this.initSwiper()
      }      
    },
    
    bindThumbs:function(){
      var _this = this;   
      this.thumbs.find('.js-prod-gal-swiper-thumb').on('click mouseover',function(e){
        e.preventDefault()
        _this.thumbnail_handler($(this))
      })
    },
    
    //handler for thumbnail click
    thumbnail_handler:function($el){
      $el.addClass('active').siblings('a').removeClass('active') 
      
      if(this.settings.isSwiper && this.settings.items && this.settings.items.length > 0){
        this.swiper.slideTo($el.index(),0)
      }
      
      if(!this.settings.isSwiper){
        this.updateFeaturedImgage()
      }
    
    },
    
    update_handler:function(sku){
      var _this = this
      if(_this.settings.loadingClass && _this.settings.loadingClassElement){
        _this.settings.loadingClassElement.addClass(_this.settings.loadingClass)
      }
      this.update_thumbs(sku).then(function(){
        if(_this.settings.loadingClass && _this.settings.loadingClassElement){
          _this.settings.loadingClassElement.removeClass(_this.settings.loadingClass)
        }
      })
    },
    
    //update the product thumbs
    update_thumbs:function(sku){
      var _this = this
      _this.current_sku = sku
      
      return new Promise(function(resolve,reject){
    
        var thumbGroup = _this.settings.items.filter(function(slide){
          return slide.sku.includes(sku)
          //return slide.sku.split(',').indexOf(sku) > -1
        })
        const thumbs = _this.getThumbs(thumbGroup[0])
         _this.thumbSwiper.removeAllSlides();
         _this.thumbSwiper.appendSlide(thumbs)
         _this.thumbSwiper.update()
         _this.thumbSwiper.slideTo(0)
        _this.bindThumbs()
        if(_this.swiper){
          _this.update_slides(sku).then(function(){
            resolve()
          })
        }else{
          resolve()
        }
      })
    },
    
    getThumbs:function(thumbGroup){
      var thumbs = []
      thumbGroup.images.forEach(function(img,index){
        var active = ''
        if(index == 0){
           active = 'active'
        }
        var thumb = `
        <button class="d-block js-prod-gal-swiper-thumb swiper-slide btn-reset ${active}">
          <img loading="lazy" alt="${img.alt}" src="${img.src[128]}" width="${img.width}" height="${img.height}" alt="${thumbGroup.sku}">
        </button>`
        thumbs.push(thumb)
      })
      return thumbs
    },
    
    
    //reg feat image update
    updateFeaturedImgage:function(){
      var src = this.thumbs.find('.active').prop('href')
      this.featImg.prop('src',src)
    },
    
    //swiper slide 
    initSwiper:function(){
      var _this = this
      //init swiper
      this.swiper = new Swiper(this.settings.swiperContainer, {
        loop: false,
        freeMode: false,
        slidesPerView: 1,
        speed:500,
        spaceBetween:0,
         navigation: {
          nextEl: `.js-prod-gal-nav-next`,
          prevEl: `.js-prod-gal-nav-prev`,
        },
        loazyLoad:true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount:1 ,
        },
        autoHeight: false,
        preloadImages: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },    
      })
      
      this.swiper.on('slideChange',function(){
        _this.updateThumbsFromSlider()
      })
      
      
      this.thumbSwiper = new Swiper(this.settings.thumbsSwiperContainer, {
        loop: false,
        freeMode: false,
        direction: 'vertical',
        slidesPerView:6,
        spaceBetween:10,
        loazyLoad:true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount:4 ,
        },
        watchSlidesProgress :true,
        navigation:this.settings.thumbsSwiperContainerNavigation,
        autoHeight: false,
        preloadImages: false,
        breakpoints: {
          736:{
            slidesPerView:7,
          },
          1024:{
            slidesPerView:9.5,
          }
        },
      }) 
     
      //this.swiper.controller.control = this.thumbSwiper
      
    },
    
    getSlides:function(sliderGroup){
     
      var slides = []
      sliderGroup.images.forEach(function(img,index){
        const srcSets = Object.keys(img.src).map( size => {
          return `${img.src[size]} ${size}w`
        }).join(',')
        var slide = `<li class="swiper-slide" data-sku="${sliderGroup.sku}">
       
                     ${!img.video ? `
                     <img src="${img.src[512]}"
                          srcset="${srcSets}"
                          class="block-12/12 d-block" 
                          loading="${index == 0 ? 'eager' : 'lazy'}"
                          preload="${index == 0 ? 'true' : 'false'}"
                          data-aspect="${img.aspect_ratio}"
                          alt="${ img.alt }" 
                          width="${ img.width }"
                          height="${ img.height }"> 
                     ` : `
                     <video  loop autoplay muted playsinline poster="${img.src}" 
                             class="block-12/12" src="${img.video}" loading="lazy">
                             Your browser does not support the video tag.
                     </video>
                     `}
                 
                     </li>`
        slides.push(slide)
      })
      return slides
    },
    
    update_slides:function(sku){
      var _this = this
      return new Promise(function(resolve,reject){
        //remove all slides
        var sliderGroup = _this.settings.items.filter(function(slide){
          return slide.sku.includes(sku)
        })
        const {activeIndex} = _this.swiper
        const currentSlides = _this.swiper.slides.map((item,index) => index)
        const newSlides = _this.getSlides(sliderGroup[0])
        if(window.wbsk_customizer && wbsk_customizer.is_init){
          currentSlides.shift()
          newSlides.shift()
        }
        _this.swiper.removeSlide(currentSlides);
        _this.swiper.appendSlide(newSlides)
        _this.swiper.update()
        _this.swiper.slideTo(activeIndex,0)
        resolve()
      })
    },
    
    updateThumbsFromSlider:function(){
      var slideIndex = this.swiper.activeIndex
      this.thumbs.find('.js-prod-gal-swiper-thumb').removeClass('active').eq(slideIndex).addClass('active')
      const activeThumb = this.thumbs.find('.js-prod-gal-swiper-thumb').eq(slideIndex)
      const activeThumbIsVisible = activeThumb.hasClass('swiper-slide-visible')
      const activeThumbNextIsVisible = activeThumb.next() && activeThumb.next().hasClass('swiper-slide-visible') ? true : false
      const activeThumbPrevIsVisible = activeThumb.prev() && activeThumb.prev().hasClass('swiper-slide-visible') ? true : false
      const offset = activeThumbPrevIsVisible ? 1 : activeThumbNextIsVisible ? -1 : 0
      if(!activeThumbIsVisible || !activeThumbPrevIsVisible || !activeThumbNextIsVisible){
        this.thumbSwiper.slideTo(slideIndex + offset)
      }
    },
        
  }

  $.fn.wbskGal = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskGal', new wbskGal(this, settings))
    })
  }

}(jQuery, window));


